import _ from 'lodash';
import _v from '../vars';

_.templateSettings = { // LoDash template settings
    interpolate: /\{\{(.+?)\}\}/g,
    evaluate: /<@(.+?)@>/g
};

const _t = {

    feedLoader: _.template(`<div class="new-loading-screen">
								<div name class="pers-feed-item plchldr">
									<div class="plchldr-ln">
									</div>
									<div class="plchldr-ln">
									</div>
									<div class="plchldr-ln">
									</div>
									<div class="plchldr-ln">
									</div>
								</div>
							</div>`),

    feedItem: _.template(`<a class="pers-feed-item news" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" href="{{ uri }}" onclick="wmdTrack('{{ trackingValue }}', this);">
                                        <@ if (imageUrl != '') { @>
                                            <div class="pers-img-wrap">
                                            <img src="{{ imageUrl }}" alt="Medscape Logo" class="pers-img" />
                                            </div>
                                        <@ } @>
                                        <@ if (false) { @>
                                            <div class="pers-content"><span class="trending-icon"></span> Trending among Cardiologists</div>
                                        <@ } @>
                                        <div class="pers-header">{{ title }}</div>
                                        <div class="pers-subheader"><div class="pers-pubname">{{ publicationName }}</div>
											<@ if (publicationDate != '') { @>
												<div class="pers-date">{{ publicationDate }}</div>
											<@ } @>
                                            <div class="pers-comments">
												<span class="viafoura-commentcount" data-vf-article-id="{{ uri.split('?')[0].match(/[^/-]+$/)[0] }}" data-vf-section-uuid="{{ vfUuid }}"></span>
                                            </div>
                                        </div>
										<div class="pers-card-toolbar">
											<div class="pers-like"><div class="pers-like-text"><span class="pers-like-count"></span> Like</div></div>
											<div class="pers-share"><div class="pers-share-text">Share</div>
												<div class="share-layer">
													<div class="share-icon facebook"></div>
													<div class="share-icon twitter"></div>
													<div class="share-icon linkedin"></div>
													<div class="share-icon whatsapp"></div>
													<!-- <div class="share-icon email"></div> -->
												</div>
											</div>
											<div class="pers-save"><div class="pers-save-text">Save</div></div>
										</div>
                                </a>
                                `),

    thirdPartyFeedItem: _.template(`<div class="pers-feed-item thirdp" data-id="{{aspenNid}}" data-uri="{{ uri }}" data-title="{{ title }}">
											<@ if (imageUrl != '') { @>
												<div class="pers-img-wrap">
													<img src="{{ imageUrl }}" alt="Medscape Logo" class="pers-img" />
													<@ if (imageCredit != '') { @>
														<div class="pers-img-attribution">{{ imageCredit }}</div>
													<@ } @>
												</div>
											<@ } @>
											<div class="pers-subheader"><div class="pers-pubname">{{ publicationName }}</div>
											<@ if (publicationDate != '') { @>
												<div class="pers-date">{{ publicationDate }}</div>
											<@ } @>
											</div>
											<div class="pers-header">{{ title }}</div>
											<div class="pers-third-party-view-summary">View Summary</div>
											<div class="details-section">
												<div class="pers-third-party-details">{{ teaser }}</div>
												<div class="pers-third-party-read-on-text">Read on&ensp;</div><a href="{{ uri }}" onclick="wmdPageLink('{{ trackingValue }}', this);" rel="nofollow" target="_blank" class="pers-third-party-read-on">{{ publicationName }}</a>
											</div>
											<div class="pers-third-party-view-less">View less</div>
											<@ if (imageCredit != '' && imageUrl != '') { @>
												<div class="pers-img-attribution-mobile">{{ imageCredit }}</div>
											<@ } @>
									</div>
									`),

    cmeFeedItem: _.template(`<a class="pers-feed-item cme" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" data-img="{{ imageUrl }}" data-credits="{{ credits }}" data-track="{{ trackingValue }}" href="{{ uri }}">
									<div class="pers-img-wrap">
										<@ if (imageUrl != '') { @>
											<img src="{{ imageUrl }}" alt="Medscape Logo" class="pers-img" />
										<@ } @>
									</div>
									<div class="pers-supertitle">{{cmeTagName}}</div>
									<div class="pers-header">{{ title }}</div>
									<div class="pers-subheader"><div class="pers-pubname">Medscape CME & Education</div> <div class="pers-credits">{{ credits }}</div></div>
									<div class="pers-card-toolbar">
										<div class="pers-like"><div class="pers-like-text"><span class="pers-like-count"></span> Like</div></div>
										<div class="pers-share"><div class="pers-share-text">Share</div>
											<div class="share-layer">
												<div class="share-icon facebook"></div>
												<div class="share-icon twitter"></div>
												<div class="share-icon linkedin"></div>
												<div class="share-icon whatsapp"></div>
												<!-- <div class="share-icon email"></div> -->
											</div>
										</div>
										<div class="pers-save"><div class="pers-save-text">Save</div></div>
									</div>
							</a>`),


    dpFeedItem: _.template(`<a class="pers-feed-item dp" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" href="{{ uri }}" onclick="wmdTrack('{{ trackingValue }}', this);">
											 <@ if (imageUrl != '') { @>
                                            <div class="pers-img-wrap">
                                            <img src="{{ imageUrl }}" alt="Medscape Logo" class="pers-img" />
                                            </div>
                                        	<@ } @>                                        	
											<div class="pers-supertitle">{{ superTitle }}</div>
											<div class="pers-header">{{ title }}</div>
											<div class="pers-subheader"><div class="pers-pubname">{{ publicationName }}</div>
											<@ if (publicationDate != '') { @>
												<div class="pers-date">{{ publicationDate }}</div>
											<@ } @>
											<div class="pers-comments">
												<span class="viafoura-commentcount" data-vf-article-id="{{ uri.split('?')[0].match(/[^/-]+$/)[0] }}" data-vf-section-uuid="{{ vfUuidDP }}"></span>
											</div>											
											<div class="video-icon"></div></div>
											<div class="pers-card-toolbar">
												<div class="pers-like"><div class="pers-like-text"><span class="pers-like-count"></span> Like</div></div>
												<div class="pers-share"><div class="pers-share-text">Share</div>
													<div class="share-layer">
														<div class="share-icon facebook"></div>
														<div class="share-icon twitter"></div>
														<div class="share-icon linkedin"></div>
														<div class="share-icon whatsapp"></div>
														<!-- <div class="share-icon email"></div> -->
													</div>
												</div>
												<div class="pers-save"><div class="pers-save-text">Save</div></div>
											</div>
									</a>
									`),


    compReportFeedItem: _.template(`<a class="pers-feed-item ss comp" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" href="{{ uri }}" class="pers-feed-link" onclick="wmdTrack('{{ trackingValue }}', this);">
													<@ if (imageUrl != '') { @>
														<div class="pers-img-wrap">
														<img src="{{ imageUrl }}" alt="Medscape Logo" class="pers-img" />
														</div>
													<@ } @>
													<div class="compreport-header">MEDSCAPE REPORT</div>
													<div class="pers-header">{{ title }}</div>
													<div class="pers-card-toolbar">
														<div class="pers-like"><div class="pers-like-text"><span class="pers-like-count"></span> Like</div></div>
														<div class="pers-share"><div class="pers-share-text">Share</div>
															<div class="share-layer">
																<div class="share-icon facebook"></div>
																<div class="share-icon twitter"></div>
																<div class="share-icon linkedin"></div>
																<div class="share-icon whatsapp"></div>
																<!-- <div class="share-icon email"></div> -->
															</div>
														</div>
														<div class="pers-save"><div class="pers-save-text">Save</div></div>
													</div>
											</a>
											`),


    slideshowFeedItem: _.template(`<a class="pers-feed-item ss" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" href="{{ uri }}" onclick="wmdTrack('{{ trackingValue }}', this);">
													<@ if (imageUrl != '') { @>
														<div class="pers-img-wrap">
														<img src="{{ imageUrl }}" alt="Medscape Logo" class="pers-img" />
														</div>
													<@ } @>
													<div class="pers-header">{{ title }}</div>
													<div class="pers-subheader"><div class="pers-pubname">{{ publicationName }}</div>
													<@ if (publicationDate != '') { @>
														<div class="pers-date">{{ publicationDate }}</div>
													<@ } @>
														<div class="pers-comments">
															<span class="viafoura-commentcount" data-vf-article-id="{{ uri.split('?')[0].match(/[^/-]+$/)[0] }}" data-vf-section-uuid="{{ vfUuid }}"></span>
														</div>
													</div>
													<div class="pers-card-toolbar">
														<div class="pers-like"><div class="pers-like-text"><span class="pers-like-count"></span> Like</div></div>
														<div class="pers-share"><div class="pers-share-text">Share</div>
															<div class="share-layer">
																<div class="share-icon facebook"></div>
																<div class="share-icon twitter"></div>
																<div class="share-icon linkedin"></div>
																<div class="share-icon whatsapp"></div>
																<!-- <div class="share-icon email"></div> -->
															</div>
														</div>
														<div class="pers-save"><div class="pers-save-text">Save</div></div>
													</div>
											</a>`),

	alertFeeds: _.template(`<div class="pers-feed-item pers-callout one-line">
								<a href="{{url}}" class="pers-feed-link" onclick="wmdTrack('fy-callout_alert', this);">
									<div class="pers-header"><div class="alert-tag">ALERT</div>{{ title }}</div>
								</a>
							</div>`),

	reportFeeds: _.template(`<div class="pers-feed-item pers-callout">
								<a href="{{ url }}" class="pers-feed-link" onclick="wmdTrack('fy-callout_report', this);">
								<@ if (thumb != '') { @>
									<div class="pers-img-wrap">
										<img src="{{ thumb }}" alt="Medscape Logo" class="pers-img" />
									</div>
									<@ } @>
								<div class="pers-supertitle">{{ supertitle }}</div>
								<div class="pers-header">{{ title }}</div>
								</a>
							</div>`),

	liveFeedItem : _.template(`<a class="pers-feed-item live" data-id="{{ contentId }}" data-uri="{{ uri }}" data-title="{{ title }}" href="{{ uri }}" class="pers-feed-link">
												<@ if (imageUrl != '') { @>
													<div class="pers-img-wrap pers-live-event-image">
														<img src="{{ imageUrl }}" alt="Medscape Logo" class="pers-img" />
													</div>
												<@ } @>
												<div class="pers-accredited-header"><span class="pers-accredited">ACCREDITED</span><span class="pers-live-event">LIVE EVENT</span></div>
												<div class="pers-header">{{ title }}</div>
												<div class="pers-subheader">
													<span class="pers-live-date">{{ liveDate }}</span>
													<span class="pers-live-location">{{ liveLocation }}</span>
												</div>
										</a>`),

	conferenceCalloutFeeds: _.template(`<div class="pers-feed-item pers-callout one-line">
											<a href="{{linkUrl}}" class="pers-feed-link">
												<div class="pers-header"><div class="coverage-tag">COVERAGE FROM</div>{{ title }}<div class="pers-right-arrow"></div></div>
											</a>
										</div>`),

};

export default _t;